"use strict"
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : { default: e }
}
function Fade(e, t) {
  function o(e) {
    function t() {
      var t = p || u || i || a || l || s,
        o = void 0,
        r = void 0
      if (t) {
        var d = n ? "50px" : "20px",
          f = _ && e
        ;(o = p ? (f ? "" : "-") + d : u ? (f ? "-" : "") + d : "0"),
          (r = a || l ? (f ? "" : "-") + d : i || s ? (f ? "-" : "") + d : "0")
      }
      return (0, _globals.animation)(
        (e ? "to" : "from") +
          " {opacity: 0;" +
          (t ? " transform: translate3d(" + o + ", " + r + ", 0);" : "") +
          "}\n         " +
          (e ? "from" : "to") +
          " {opacity: 1;transform: none;} "
      )
    }
    return { reverse: p, make: t }
  }
  var r = e.out,
    p = e.left,
    u = e.right,
    i = e.up,
    a = e.down,
    l = e.top,
    s = e.bottom,
    n = e.big,
    _ = e.opposite,
    d = (0, _objectWithoutProperties3.default)(e, [
      "out",
      "left",
      "right",
      "up",
      "down",
      "top",
      "bottom",
      "big",
      "opposite"
    ])
  return t
    ? _react2.default.createElement(
        _Reveal2.default,
        (0, _extends3.default)({}, d, { in: o(!1), out: o(!0) })
      )
    : o(r)
}
Object.defineProperty(exports, "__esModule", { value: !0 })
var _extends2 = require("babel-runtime/helpers/extends"),
  _extends3 = _interopRequireDefault(_extends2),
  _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties"),
  _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2),
  _react = require("react"),
  _react2 = _interopRequireDefault(_react),
  _propTypes = require("prop-types"),
  _Reveal = require("./Reveal"),
  _Reveal2 = _interopRequireDefault(_Reveal),
  _globals = require("./globals"),
  propTypes = {
    out: _propTypes.bool,
    left: _propTypes.bool,
    right: _propTypes.bool,
    top: _propTypes.bool,
    bottom: _propTypes.bool,
    big: _propTypes.bool,
    opposite: _propTypes.bool
  },
  defaultProps = {}
;(Fade.propTypes = propTypes),
  (Fade.defaultProps = defaultProps),
  (exports.default = Fade),
  (module.exports = exports.default)



//////////////////
// WEBPACK FOOTER
// ./~/react-reveal/Fade.js
// module id = 27
// module chunks = 168707334958949